import { IconButton, IconButtonProps } from '@mui/material';

interface EditActionButtonProps extends Omit<IconButtonProps, 'children'> {
    sizePx?: number;
    iconSizePx?: number;
}

const EditActionButton = ({
    sizePx = 38,
    iconSizePx = 16,
    sx,
    ...props
}: EditActionButtonProps) => {
    return (
        <IconButton
            {...props}
            aria-label={props['aria-label'] ?? 'Modifier'}
            sx={{
                width: sizePx,
                height: sizePx,
                borderRadius: '8px',
                border: theme => `1px dashed ${theme.palette.neutralWhite.main}`,
                color: 'neutralWhite.main',
                '&:hover': { backgroundColor: 'transparent' },
                '& i': { fontSize: `${iconSizePx}px` },
                ...sx,
            }}>
            <i className="fi fi-br-pencil" />
        </IconButton>
    );
};

export default EditActionButton;
